import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "@/contexts/AuthContext";
import { Nav } from "@/pages/Dashboard";
import { Lock, CheckCircle, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProgramPage() {
  const [weeks, setWeeks] = useState([]);

  useEffect(() => {
    apiGet(`${API}/program/weeks`)
      .then(r => setWeeks(r.data)).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#F7F5F0' }}>
      <Nav />
      <main className="px-6 sm:px-12 py-10 max-w-5xl mx-auto">
        <h1 className="text-4xl sm:text-5xl mb-3" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>The 6-Week Journey</h1>
        <p className="text-base mb-12" style={{ color: '#5B665E' }}>Each week builds on the last. Complete them in order to unlock the full experience.</p>

        <div className="space-y-5">
          {weeks.map((w, i) => {
            const isLocked = w.status === 'locked';
            const isCompleted = w.status === 'completed';
            return (
              <div
                key={w.week_num}
                className={`earthy-card flex flex-col sm:flex-row items-start sm:items-center gap-5 fade-in ${isLocked ? 'opacity-50' : ''}`}
                style={{ animationDelay: `${i * 0.05}s`, opacity: 0, ...(isCompleted ? { borderColor: '#4A5D4E' } : {}) }}
                data-testid={`program-week-${w.week_num}`}
              >
                <div className="w-12 h-12 rounded-md flex items-center justify-center text-lg flex-shrink-0"
                  style={{ background: isCompleted ? '#4A5D4E' : 'rgba(74,93,78,0.1)', color: isCompleted ? '#F7F5F0' : '#4A5D4E', fontFamily: 'Cormorant Garamond, serif', fontWeight: 600 }}>
                  {w.week_num}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <h2 className="text-xl" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>{w.title}</h2>
                  </div>
                  <p className="text-sm" style={{ color: '#5B665E' }}>{w.subtitle}</p>
                </div>
                {isLocked ? (
                  <Lock size={20} strokeWidth={1.5} style={{ color: '#5B665E' }} />
                ) : isCompleted ? (
                  <div className="flex items-center gap-3">
                    <CheckCircle size={20} strokeWidth={1.5} style={{ color: '#4A5D4E' }} />
                    <Link to={`/program/${w.week_num}`} className="earthy-btn earthy-btn-secondary text-xs py-2 px-3" data-testid={`review-week-${w.week_num}`}>Review</Link>
                  </div>
                ) : (
                  <Link to={`/program/${w.week_num}`} className="earthy-btn earthy-btn-primary text-sm flex items-center gap-1.5" data-testid={`start-week-${w.week_num}`}>
                    Start <ArrowRight size={14} strokeWidth={1.5} />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
